// ---
// Патч чинит неудаляющиеся из canonicalState удаленные записи
// See: https://github.com/emberjs/data/issues/2666
//      https://github.com/emberjs/data/issues/2984
// ---
DS.ManyArray.reopen({
  flushCanonical: function() {

    var filter = Ember.ArrayPolyfills.filter;
    var toSet = filter.call(this.canonicalState, function(record) {
      return !record.get('isDeleted');
    });


    //a hack for not removing new records
    //TODO remove once we have proper diffing
    var newRecords = this.currentState.filter(function(record) {
      return record.get('isNew');
    });
    toSet = toSet.concat(newRecords);
    var oldLength = this.length;
    this.arrayContentWillChange(0, this.length, toSet.length);
    this.set('length', toSet.length);
    this.currentState = toSet;
    this.arrayContentDidChange(0, oldLength, this.length);
    //TODO Figure out to notify only on additions and maybe only if unloaded
    this.relationship.notifyHasManyChanged();
    this.record.updateRecordArrays();
  }
});
